<section class="forgot-password-dialog">
  <!-- dialog header -->
  <div>
    <div class="forgot-password-dialog__header">
      <!-- title -->
      <h4 class="forgot-password-dialog__title">
        @if (authService.userForgotPassState().state === 0){
          {{ 'global.forgotPassword' | translate }}
        } @else if (authService.userForgotPassState().state === 1){
          {{ 'toastMessages.loginTitle' | translate }}
        }
      </h4>
      <!-- close button -->
      <button (click)="close()">
        <i class="iconsax forgot-password-dialog__icon" icon-name="x"></i>
      </button>
    </div>
  </div>
  @if (authService.userForgotPassState().state === 0) {
    <form (submit)="submit()" [formGroup]="forgotForm">
      <div class="forgot-password-dialog__field">
        <pwj-phone-number
          formControlName="mobile"
          label="global.phone_number"
          placeholder="global.enter_your_phone"
          icon="phone"></pwj-phone-number>
      </div>
      <div class="forgot-password-dialog__submit">
        <pwj-button
          variant="primary"
          type="submit"
          icon="chevron-right"
          size="large"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          [disabled]="!forgotForm.dirty"
        >{{ 'global.resetPassword' | translate }}
        </pwj-button>
      </div>
    </form>
  } @else if (authService.userForgotPassState().state === 1) {
    <form (submit)="submitOtp()" [formGroup]="forgotOtpForm">
      <div class="forgot-password-dialog__field">
        <pwj-input
          formControlName="password"
          type="password"
          label="auth.passwordLabel"
          placeholder="auth.passwordPlaceholder"
          icon="lock-2"
          [messages]="{
              required: 'auth.passwordIsRequired',
              minlength: 'auth.passwordLength',
              }"></pwj-input>
      </div>
      <div class="forgot-password-dialog__field">
        <pwj-input
          formControlName="password_confirmation"
          type="password"
          label="auth.repasswordLabel"
          placeholder="auth.repasswordPlaceholder"
          icon="lock-2"
          [messages]="{ required: 'auth.repasswordIsRequired', }"></pwj-input>
      </div>
      @if (forgotOtpForm.errors?.['passwordNotMatch']) {
        <span class="forgot-password-dialog__password-no-match">{{
            'auth.passwordNoMatch' | translate
          }}</span>
      }
      <div class="forgot-password-dialog__field">
        <pwj-input
          pwjOnlyNumber
          formControlName="otp"
          label="auth.verificationCode"
          placeholder="auth.enterVerificationCode"
          icon="lock-2"
          [messages]="{
                required: 'auth.verificationCodeIsRequired',
              }"></pwj-input>
      </div>
      <div class="forgot-password-dialog__resend-otp">
        @if (!showResendButton) {
          <p class="otp-timer">
                <span class="forgot-password-dialog__numbers">
                  {{ formattedTimer }}
                </span>
            <span class="forgot-password-dialog__description">
                  {{ 'auth.receiveCode' | translate }}
                </span>
          </p>
        } @else {
          <button
            type="button"
            class="resend-otp-button"
            (click)="resendOtp()">
                <span>
                  {{ 'auth.getCodeAgain' | translate }}
                </span>
            <span>
                  <i
                    class="iconsax resend-otp-button__icon"
                    icon-name="chevron-right"></i>
                </span>
          </button>
        }
      </div>
      <div class="forgot-password-dialog__submit">
        <pwj-button
          variant="primary"
          type="submit"
          icon="chevron-right"
          size="large"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          [disabled]="!forgotOtpForm.dirty || isVerifyOtpBtnDisable"
        >{{ 'global.send' | translate }}
        </pwj-button>
      </div>
    </form>
  }
</section>
